module.exports = __webpack_public_path__ + "media/marketplace_fund/cover-5c65a7b8.png";